<div class="info-page">
  <div class="audio-page">

    <div
      #audioContainer
      class="container-fluid audio-bar-container position-fixed"
      [ngClass]="{ 'display-audio-bar': initScroll}"
    >
      <div
        class="overflow-hidden justify-content-center audio-bar-box"
        *ngIf="narration != ''"
        [ngClass]="{'o-0': audioHidden}"
      >
      <div class="audio-bar-title">{{ 'playNarration' | translate }}</div>
        <div class="col-12 col-xl-8 px-2 audio-bar pb-2 pt-3">
          <div class="row justify-content-center">
            <div class="col-4">
              <div class="row">
                <div class="col-auto ml-auto mr-1 text-center">
                  <button
                    (click)="rewind()"
                    class="rwnd mb-2 position-relative px-0"
                  >
                    <img
                      class="w-100"
                      src="../../../assets/rewind-default.svg"
                      alt="Rewind button icon"
                    />
                    <img
                      [@rewindAnimate]="rewindAnimateToggle"
                      class="w-100 position-absolute l-0"
                      src="../../../assets/rewind-selected.svg"
                    /></button
                  ><br />
                  <ng-template [ngIf]="language == 'en'">REWIND</ng-template>
                  <ng-template [ngIf]="language == 'es'">REBOBINAR</ng-template>
                </div>
              </div>
            </div>
            <div class="col-4 text-center no-wrap px-0">
              <button class="play mb-2 pb-1 px-0" (click)="play(!playAudio)">
                <img
                  *ngIf="audioState != 'playing'"
                  class="w-100"
                  src="../../../assets/play-default.svg"
                />
                <img
                  *ngIf="audioState == 'playing'"
                  class="w-100"
                  src="../../../assets/pause-active.svg"
                /></button
              ><br />
              <span *ngIf="audioState != 'playing'">
                <ng-template [ngIf]="language == 'en'">PLAY</ng-template>
                <ng-template [ngIf]="language == 'es'">JUGAR</ng-template>
              </span>
              <span *ngIf="audioState == 'playing'">
                <ng-template [ngIf]="language == 'en'">PAUSE</ng-template>
                <ng-template [ngIf]="language == 'es'">PAUSAR</ng-template>
              </span>
              <ng-template [ngIf]="language == 'en'"> NARRATION</ng-template>
              <ng-template [ngIf]="language == 'es'"> NARRACIÓN</ng-template>
            </div>
            <div class="col-4">
              <div class="row">
                <div class="col-auto mr-auto ml-1 text-center">
                  <button (click)="nextStop()" class="next mb-2 pb-1 px-0">
                    <img
                      class="w-100"
                      src="../../../assets/nextstop-default.svg"
                    /></button
                  ><br />
                  <ng-template [ngIf]="language == 'en'">NEXT STOP</ng-template>
                  <ng-template [ngIf]="language == 'es'"
                    >SIGUIENTE PARADA</ng-template
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex support-sonoma-box fixed-bottom justify-content-start w-100 m-auto"
      [ngClass]="{'o-0': !initScroll}"
      >
        <div class="support-sonoma">
            <h4>{{ 'supportSonamaInfo.supportHead' | translate }}</h4>
            <div class="d-flex flex-column align-items-center">
              <button type="button" class="text-white" (click)="openPage('http://www.sonomaplazahistory.com/donate')">{{ 'supportSonamaInfo.donateNow' | translate }}</button>
              <button type="button" class="text-white" (click)="openPage('https://sonomaplazahistory.us1.list-manage.com/subscribe?u=9242ed7d73da1ed8f9ffc4323&id=d42d972003')">{{ 'supportSonamaInfo.mailingList' | translate }}</button>
            </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container-flud">
    <app-page-layout [imagePath]="'../../assets/banners/desktop/banner'+(stopNumber+1)+'.png'">
    <div class="bg-white">
      <!-- <div class="stop-details pt-4">
        <div class="stop-name-number d-flex align-items-center justify-content-between">
            <div class="d-flex">
                <img src="../../../assets/Vector-icon.svg" width="13px" height="18px" alt="" />
                <span class="pl-4">{{ "Stop " + (stopNumber + 1) + " of 10"}}</span>
            </div>
            <span class="font-weight-bold">{{ title_name[stopNumber] + ", " + (stopNumber + 1) }}</span>
        </div>

        <div class="audio-quiz d-flex align-items-center justify-content-between">
            <div class="d-flex" *ngIf="narration != ''">
                <img src="../../../assets/PlayIcon.svg" width="14px" height="14px" alt="" />
                <span class="pl-4">Audio Narration Available</span>
            </div>
            <div *ngFor="let item of info" >
              <div class="d-flex mt-1" *ngIf="item.quiz">
                  <img src="../../../assets/QuestionMark.svg" class="mt-1" width="14px" height="14px" alt="" />
                  <span class="ml-3">Quiz</span>
              </div>
            </div>
        </div>
      </div> -->

        <div class="container-fluid intro ">
          <div class="row">
            <div class="col-12 ">
              <h6 class="text-center">{{ "Stop " + (stopNumber + 1) + " of 10"}}</h6>
              <!-- <h1 class="text-center max-375 mx-auto intro-title">{{ intro_title[stopNumber] }}</h1>
              <h3 class="text-center " >{{ subTitle }}</h3> -->
              <h1 class="text-center max-375 mx-auto intro-title">{{ banner[stopNumber][0] }}</h1>
              <h2 class="font-weight-normal">{{ infos[stopNumber][0].location || infos[stopNumber][0].title || banner[stopNumber][0] }}</h2>
              <div class="row justify-content-center  down-arrow">
                <div class="col-auto">
                  <img
                    src="../../../assets/down-arrow.svg"
                    alt="Instructional arrow pointing to audio module"
                    class="arrow-animation text-center"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid info pb-4  position-relative">
          <div
            *ngIf="narration == ''"
            class="row justify-content-center py-2 no-audio"
          >
            <img src="../../../assets/no-audio.svg" />
            <p class="pl-2 my-auto">
              <ng-template [ngIf]="language == 'en'"
                >Audio playback is <u>not available</u> for this stop</ng-template
              >
              <ng-template [ngIf]="language == 'es'"
                >Reproducción de audio no disponible para esta parada</ng-template
              >
            </p>
          </div>
          <div *ngFor="let item of info" [ngClass]="'pt-' + item.pt">
            <app-timebar
              *ngIf="item.timebar"
              [date]="item.timebar.date"
              [title]="item.timebar.title"
            ></app-timebar>
            <div *ngIf="item.img" class="row justify-content-center flex-column">
              <div
                [ngClass]="{
                  'col-12 px-4': item.img.size == 'lg',
                  'col-10': item.img.size == 'md',
                  'col-6 px-3': item.img.size == 'sm'
                }"
                class="d-flex  align-items-center flex-column max-375 m-auto overflow-hidden item-images-main"
              >
                <ng-lottie *ngIf="item.img.lottieImg" width="100%" [options]="options"></ng-lottie>
                <div *ngIf="!item.img.lottieImg">                  
                  <img *matches="'desktop'" class="w-100 items-image-style" [src]="item.img.desktopUrl" [alt]="item.img.alt" />
                  <img *matches="'mobile'" class="w-100 items-image-style" [src]="item.img.mobileUrl" [alt]="item.img.alt" />
                </div>
              </div>
              <p class="mt-2 footnote min-375 mx-auto">{{ item.img.footnote }}</p>
            </div>
            <div *ngIf="item.p" class="row justify-content-center">
              <div class="col-12 px-4 sub-description-alignment">
                <p [innerHTML]="item.p" class="max-375 mx-auto"></p>
              </div>
            </div>
            <div *ngIf="item.list" class="row justify-content-center">
              <div class="col-10 d-flex flex-column align-items-center">
                <strong class="ul-title">{{ item.list.title }}</strong>
                <ul class="pl-3 ml-1 mt-2">
                  <li *ngFor="let val of item.list.values">
                    <p class="mb-0 font-weight-bold">{{ val }}</p>
                  </li>
                </ul>
              </div>
            </div>
            <div *ngIf="item.videoplay">
            <app-video [videoDetails]="item.videoplay"></app-video>
            </div>
            <div *ngIf="item.audioPlay">
              <div class="col-10 m-auto d-flex pt-3 pb-3 audio-playback flex-column align-items-center">
                <h5 class="font-weight-bold">{{ item.audioPlay.title }}</h5>
                <p class="font-weight-light">
                  {{ item.audioPlay.p }}
                </p>
              </div>
            </div>
            <div
              *ngIf="item.lgTxt"
              class="row justify-content-center"
              [class.dark]="item.lgTxt.dark"
            >
              <div class="col-12 px-4">
                <p
                  [innerHTML]="item.lgTxt.p"
                  class="lgTxt mb-0"
                  [ngClass]="{ 'py-4': true, 'text-white': item.lgTxt.dark }"
                ></p>
              </div>
            </div>

            <div *ngIf="item.title" class="row pt-2">
              <div class="col-12 px-4 d-flex justify-content-center item-title welcome-text-style">
                <h5 class="title">{{ item.title }}</h5>
              </div>
            </div>
            <div *ngIf="item.h1" class="row justify-content-center">
              <div class="col-12 px-4">
                <h1 [innerHTML]="item.h1"></h1>
              </div>
            </div>
            <div *ngIf="item.zoom" class="row mt-4 mb-4 justify-content-center">
              <div class="col-11 px-0 overflow-hidden">
                <img *matches="'desktop'"
                  appZoom
                  class="w-100"
                  [src]="item.zoom.desktopUrl"
                  [alt]="item.zoom.alt"
                />
                  <img *matches="'mobile'"
                  appZoom
                  class="w-100"
                  [src]="item.zoom.mobileUrl"
                  [alt]="item.zoom.alt"
                />
              </div>
              <p class="footnote min-375 mt-1 ml-3">{{ item.zoom.footnote }}</p>
            </div>
            <div *ngIf="item.double_img" class="row justify-content-center max-375 m-auto">
                <div class="col-6 pr-2 pl-0 overflow-hidden text-right">
                  <img *matches="'desktop'"
                    class="w-100"
                    [src]="item.double_img.desktopUrl_a"
                    [alt]="item.double_img.alt_a"
                  />
                  <img *matches="'mobile'"
                  class="w-100 mobile-double"
                  [src]="item.double_img.mobileUrl_a"
                  [alt]="item.double_img.alt_a"
                />
                  <p class="footnote mt-2 mx-auto">{{ item.double_img.footnote_a }}</p>
                </div>
                <div class="col-6 pl-2 pr-0 overflow-hidden text-left">
                  <img *matches="'desktop'"
                    class="w-100"
                    [src]="item.double_img.desktopUrl_b"
                    [alt]="item.double_img.alt_b"
                  />
                  <img *matches="'mobile'"
                  class="w-100 mobile-second"
                  [src]="item.double_img.mobileUrl_b"
                  [alt]="item.double_img.alt_b"
                />
                  <p class="footnote mt-2 mx-auto">{{ item.double_img.footnote_b }}</p>
                </div>
            </div>
            <app-reflection
            *ngIf="item.reflection"
              [title]="item.reflection.title"
              [p]="item.reflection.p"
            ></app-reflection>
            <app-test
              *ngIf="item.test"
              [question]="item.test.question"
              [answer]="item.test.answer"
              [language]="language"
            ></app-test>
            <div *ngIf="item.quiz" class="container-fluid">
              <app-quiz
              [question]="item.quiz.question"
              [answers]="item.quiz.choices"
              [language]="language"
              ></app-quiz>
            </div>
            <div *ngIf="stopNumber === 0 && welcomeBoxVisible">
              <app-welcome-tour-stop (hide)="hideWelcomeBox()"></app-welcome-tour-stop>
            </div>
          </div>
        </div>

        <div class=" container-fluid footer-top">

          <div class="row">
            <div class="col-12 px-0 insta-link text-center  l-0 py-5">
              <img src="../../../assets/instagram-icon.svg" />
              <p class="my-5">@sonomaplazahistory</p>
              <p>
                <ng-template [ngIf]="language == 'en'"
                  >share and follow</ng-template
                >
                <ng-template [ngIf]="language == 'es'"
                  >compartir y seguir</ng-template
                >
              </p>
            </div>
          </div>
        </div>
        <!-- <div class="container-fluid mt-4">
          <div class="row">
            <div class="col-12 px-0 insta-link text-center position-absolute l-0 py-5">
              <img src="../../../assets/instagram-icon.svg" />
              <p class="my-5">@sonomaplazahistory</p>
              <p>
                <ng-template [ngIf]="language == 'en'"
                  >share and follow</ng-template
                >
                <ng-template [ngIf]="language == 'es'"
                  >compartir y seguir</ng-template
                >
              </p>
            </div>
          </div>
        </div> -->
        <div class="container-fluid next-stop">
          <div class="row overflow-hidden h-100">
            <div class="top col-12 px-5 pt-5 pb-5 text-center">
              <h1 class="pb-5" *ngIf="stopNumber < intro_title.length">
                <ng-template [ngIf]="language == 'en'">Next Stop</ng-template>
                <ng-template [ngIf]="language == 'es'">Siguiente parada</ng-template>
              </h1>
              <h1 *ngIf="stopNumber >= intro_title.length">Finish Tour</h1>
              <!-- <h2 *ngIf="stopNumber < intro_title.length" class="mt-4 mb-5 pb-5">
                {{ intro_title[stopNumber + 1] }}
              </h2> -->
            </div>
            <div class="bottom col-12 text-center pb-5">
              <div class="curve"> <button class="mt-4" (click)="nextStop()">
                <img src="../../../assets/next-arrow.svg" width="80px" height="80px"/>
              </button></div>

              <!-- <h3 *ngIf="stopNumber < intro_title.length" class="position-relative">
                <ng-template [ngIf]="language == 'en'">Let's Go!</ng-template>
                <ng-template [ngIf]="language == 'es'">¡Vamos!</ng-template>
              </h3> -->
              <h3
                *ngIf="stopNumber >= (intro_title.length - 1)"
                class="position-relative"
              >
                Tour End
              </h3>
              <p class="position-relative mt-4 m-auto text-white">
                <ng-template [ngIf]="language == 'en'"
                  >Continue to </ng-template
                >
                <ng-template [ngIf]="language == 'es'"
                  >Continua a </ng-template
                >
                <ng-template [ngIf]="stopNumber >= intro_title.length">Finish Tour</ng-template>
                <ng-template [ngIf]="stopNumber < intro_title.length">{{ intro_title[stopNumber + 1] }}</ng-template>
              </p>
            </div>
          </div>
        </div>

        <audio
          appAudio
          [play]="playAudio"
          [rewind]="rewindAudio"
          [src]="narration"
          (audioFinish)="stopAudio()"
        ></audio>

    </div>
  </app-page-layout>
  </div>

</div>
